import { StyledBroadsiderTraits } from './BroadsiderTraits.styled';
import BroadsiderTrait from './BroadsiderTrait';

const BroadsiderTraits = ({ traits = [], singleRow = false }) => {
  const rowSize = singleRow ? 1 : 2;
  const traitPairs = traits.reduce(function(result, value, index, array) {
    if (index % rowSize === 0)
      result.push(array.slice(index, index + rowSize));
    return result;
  }, []);

  return (
    <StyledBroadsiderTraits $rowsize={singleRow ? 2 : 4}>
      {traitPairs.map((p) => {
        return (<div className='traits-row'>
          {p.map((i) => (<div className={`trait-container${singleRow ? ' trait-container-single' : ''}`}><BroadsiderTrait trait={i} /></div>))}
	</div>);
      })}
    </StyledBroadsiderTraits>
  );
};

export default BroadsiderTraits;
